import { getNonEmptyProperties } from '../../utils';
export const transformProperties = ({
  propertyDefinitions,
  propertySources,
  propertyUpdates
}) => {
  const fullProperties = {};
  Object.keys(propertyUpdates).forEach(key => {
    const propertyUpdate = propertyUpdates[key];
    const propertyDefinition = propertyDefinitions[key];
    const propertySource = propertySources[key];
    fullProperties[key] = {
      // property updates
      value: propertyUpdate === null || propertyUpdate === void 0 ? void 0 : propertyUpdate.value,
      timestamp: propertyUpdate === null || propertyUpdate === void 0 ? void 0 : propertyUpdate.timestamp,
      // property definitions
      description: propertyDefinition === null || propertyDefinition === void 0 ? void 0 : propertyDefinition.description,
      label: propertyDefinition === null || propertyDefinition === void 0 ? void 0 : propertyDefinition.label,
      fieldType: propertyDefinition === null || propertyDefinition === void 0 ? void 0 : propertyDefinition.fieldType,
      name: propertyDefinition === null || propertyDefinition === void 0 ? void 0 : propertyDefinition.name,
      numberDisplayHint: propertyDefinition === null || propertyDefinition === void 0 ? void 0 : propertyDefinition.numberDisplayHint,
      // renamed property sources to avoid name collisions
      sourceDescription: propertySource === null || propertySource === void 0 ? void 0 : propertySource.description,
      sourceInstance: propertySource === null || propertySource === void 0 ? void 0 : propertySource.instance,
      sourceLabel: propertySource === null || propertySource === void 0 ? void 0 : propertySource.label,
      sourceUser: propertySource === null || propertySource === void 0 ? void 0 : propertySource.user
    };
  });
  return {
    properties: Object.values(fullProperties),
    selectedProperties: Object.keys(fullProperties)
  };
};
export const transformPropertyDefinitions = propertyDefinitions => {
  const transformedPropertyDefinitions = {};
  for (const key of Object.keys(propertyDefinitions)) {
    transformedPropertyDefinitions[key] = propertyDefinitions[key].property;
  }
  return transformedPropertyDefinitions;
};
export const transformPropertySources = ({
  propertySources,
  propertyUpdates
}) => {
  const propertiesWithValues = getNonEmptyProperties(propertyUpdates);
  const transformedSources = propertySources.filter(sourceInterpretation => propertiesWithValues.includes(sourceInterpretation.name));
  const transformedPropertySources = {};
  for (const item of transformedSources) {
    if (!(item.name in transformedPropertySources)) {
      transformedPropertySources[item.name] = item;
    }
  }
  return transformedPropertySources;
};